import React, { useState, useEffect } from 'react';
import { Card, CardContent,Grid, Typography, TextField, Select, MenuItem, Button, Divider, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { COLORS } from '../colors';
import { CorporateFare as CorporateFareIcon, CardMembership as CardMembershipIcon, LocationOn, Email, Phone, AccountCircle, Lock, DateRange, FormatListNumbered, Person , Add, Remove} from '@mui/icons-material';
import axios from 'axios';
import api from '../../Services/api';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { Link ,useNavigate} from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import Autorenew from '@mui/icons-material/Autorenew';

const useStyles = makeStyles({
 

  detail: {
    display: 'flex',
    alignItems: 'center',
   justifyContent:"center",
   marginBottom: 15
  },
  
  textField: {
    width: '80%',
    '& .MuiInputLabel-root': {
      color: 'gray', // Default label color (or set to something else)
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'gray', // Outline color to white when not focused
      },
      '&:hover fieldset': {
        borderColor: 'gray', // Optional: Outline color on hover
      },
      '&.Mui-focused fieldset': {
        borderColor: 'black', // Optional: Outline color when focused
      },
    },
    // When the field is focused, change label color to white
    '& .MuiInputLabel-root.Mui-focused': {
      color: 'gray',
    },
    // Text inside input area when focused
    '& .MuiOutlinedInput-input': {
      color: 'black', // Text color inside the input area when focused
    },
    // Ensure the text inside is visible when the field is not focused
    '& .MuiOutlinedInput-input.Mui-focused': {
      color: 'black', // Make text black when focused to keep it visible
    },
  },

});

const statesInIndia = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Ladakh', 'Lakshadweep', 'Puducherry'];
const CompanyCard = () => {
  let data1 = sessionStorage.getItem('user');
  let assessorData = JSON.parse(data1);
  let id1 = assessorData.id;
  let id2 = assessorData.companyId;
  const classes = useStyles();
  const [formData, setFormData] = useState({
    clientName: '',
    assessorId: id1,
    principleEmployer: '',
    companyId: id2,
    CorporateId:'',
    companyAddress: '',
    clientContactPersonName: '',
    clientContactPersonPhoneNumber: '',
    clientContactPersonEmailId: '',
    clientContactPersonPhoneNumber1: '',
    clientContactPersonEmailId1: '',
    stateId: '',
    placeName: '',
    pinCode: '',
    natureOfWork: '',
    // noOfWorkers:'',
    // startDate: '',
    // endDate: '',
    vendorCompanyName: '',
    vendorName: '',
    isVendor: true,
    isDeleted: false,
    vendorCompanyAddress: '',
    vendorEmail: '',
    vendorPhoneNumber: '',
    vendorEmail1: '',
    vendorPhoneNumber1: '',
    vendorStateId: '',
    vendorPlaceName: '',
    vendorPinCode: '',
    vendorUsername: '',
    vendorCode: '',
    vendorPassword: '',
    vendorContractStartDate: '',
    vendorContractEndDate: '',
  });
  const navigate=useNavigate();
  const [errors, setErrors] = useState({});
  const [clientOptions, setClientOptions] = useState([]);
  const [showPassword, setShowPassword] = React.useState(false);
  const [extraEmailVendorVisible, setExtraEmailVendorVisible] = useState(false);
  const [extraPhoneNumberVisible, setExtraPhoneNumberVisible] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');


  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const generatePassword = ( length = 12 ) => {
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const number = '0123456789';
  const special = '!@#$%^&*()_+[]{}|;:,.<>?';
  const all = lower + upper + number + special;

  if (length < 8) throw new Error("Password length must be at least 8");

  const getRandomChar = (charset) =>
    charset.charAt(Math.floor(Math.random() * charset.length));

  // Ensure at least one from each required set
  let password = [
    getRandomChar(lower),
    getRandomChar(upper),
    getRandomChar(number),
    getRandomChar(special)
  ];

  // Fill the rest with random characters from all allowed sets
  for (let i = password.length; i < length; i++) {
    password.push(getRandomChar(all));
  }

  // Shuffle the result to avoid predictable order
  return password
    .sort(() => 0.5 - Math.random())
    .join('');
};


const handleGeneratePassword = () => {
    const newPassword = generatePassword();
    handleChange({ target: { name: 'vendorPassword', value: newPassword } });
  };


  const handleAddEmailVendor = () => {
    setExtraEmailVendorVisible(prevState => !prevState);
  }

  const handlePhoneNumberVendor = () => {
    setExtraPhoneNumberVisible(prevState => !prevState);
  }

  //FETCHING LOGGED ASSESSOR CLIENT DETAILS 
  useEffect(() => {
    try{
    api.client.getClient(id2).then((response) => {
      if(response.status === 200){
      const client = response.data.data;
      setFormData(prevState => ({
        ...prevState,
        principleEmployer: client.principleEmployer || '',
        companyAddress: client.companyAddress || '',
        placeName: client.placeName || ' ',
        stateId: client.stateId || '',
        CorporateId:client.CorporateId || '',
        pinCode: client.pinCode || '',
        clientName: client.clientName || '',
        clientContactPersonName: client.clientContactPersonName || '',
        clientContactPersonPhoneNumber: client.clientContactPersonPhoneNumber || '',
        clientContactPersonEmailId: client.clientContactPersonEmailId || '',
        clientContactPersonPhoneNumber1: client.clientContactPersonPhoneNumber1 || '',
        clientContactPersonEmailId1: client.clientContactPersonEmailId1 || '',
        // startDate: client.startDate || '',
        // endDate: client.endDate || ''
      }));
      setClientOptions(response.data.data);
    }
    else if(response.status === 404){
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage("Company Profile Not Found");
    }
    else{
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage("Error fetching Client Details");
    }
  })
}
  catch(error) {
        console.error('Error fetching company names:', error);
       
      }
  }, []);



  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    const error = validateField(name, value);
    setErrors(prev => ({
      ...prev,
      [name]: error,
    }));

  };


  //VALIDATION
  const validateField = (name, value) => {
    const emailPattern = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/;
    const phonePattern = /^[6-9]\d{9}$/;
    const pinCodePattern = /^(?!000000$)[0-9]{6}$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[^\s]{8,12}$/;
   const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  
    switch (name) {
      case 'clientName':
        return value ? '' : 'Select client';
  
      case 'natureOfWork':
        return value.trim() ? '' : 'Nature of work is required';
  
      case 'vendorCompanyName':
        return value.trim() ? '' : 'Vendor Company Name is required';
  
      case 'vendorName':
        return value.trim() ? '' : 'Vendor Name is required';
  
      case 'vendorPlaceName':
        return value.trim() ? '' : 'Place Name is required';
  
      case 'vendorCompanyAddress':
        return value.trim() ? '' : 'Vendor Company Address is required';
  
      case 'vendorStateId':
        return value ? '' : 'Please select State';
  
      case 'vendorPinCode':
        return !value ? 'Pin code is required' : pinCodePattern.test(value) ? '' : 'Invalid Pin code format(245678)';
  
      case 'vendorEmail':
        return !value ? 'Email address is required' : emailPattern.test(value) ? '' : 'Invalid email address (e.g., text@email.com)';
  
      case 'vendorEmail1':
        return value && !emailPattern.test(value) ? 'Invalid email address (e.g., text@email.com)' : '';
  
      case 'vendorPhoneNumber':
        if (!value) return 'Contact number is required';
        if (!phonePattern.test(value)) return 'Invalid number (start with 6-9) and length should be 10';
        return '';
  
      case 'vendorPhoneNumber1':
        return value && !phonePattern.test(value) ? 'Invalid contact number (10 digits, start with 6-9)' : '';
  
      case 'vendorUsername':
        return value.trim() ? '' : 'Username is required';
  
      case 'vendorCode':
        return value.trim() ? '' : 'VendorCode is required';
  
      case 'vendorPassword':
        return !value
          ? 'Password is required'
          : passwordRegex.test(value)
          ? ''
          : 'Password must be 8–12 characters long, include uppercase, lowercase, number, special character, and no spaces';
  
      case 'vendorContractStartDate':
          if (!value) return 'Contract Start Date is required';
        if (!dateRegex.test(value)) return 'Invalid date format';

        return '';
       
      case 'vendorContractEndDate':
 if (!value) return 'Contract End Date is required';
        if (!dateRegex.test(value)) return 'Invalid date format';

        return '';
  
      default:
        return '';
    }
  };
  


 const validateForm = () => {
    const newErrors = {};
  
    Object.keys(formData).forEach((fieldName) => {
      const error = validateField(fieldName, formData[fieldName]);
      if (error) {
        newErrors[fieldName] = error;
      }
    });
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // ✅ returns true if no errors
  };

  //CREATING VENDOR PROFILE
  const handleSave = async () => {
    const isValid = validateForm();

    if (isValid) {
      let data = sessionStorage.getItem('user');
      let data1 = JSON.parse(data);
      let type = data1?.type;
    
      if (type !== 'assessor') {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Only assessor can create vendors");
        navigate('/');
        return;
      }
    
      try {
        console.log("Attempting to create vendor:", formData);
    
        const response = await api.vendor.createVendor(formData);
    
        if (response.status === 400) {
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage('The username is already in use. Try a different one.');
        } else if (response.status === 201) {
          const vendorData = response.data;
          sessionStorage.setItem('vendor', JSON.stringify(vendorData));
          setSnackbarOpen(true);
          setSnackbarMessage("Vendor Created Successfully!");
          setTimeout(() => {
            handleSubmit(); // This will call the master data creation
          }, 1000);
          setTimeout(() =>{
            window.location.reload();
          }, 2500);
        } else {
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage('An error occurred. Please try again.');
        }
      } catch (error) {
        console.error('Error while creating vendor:', error);
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage('Unexpected error occurred.');
      }
    }
    
  };


  //VENDOR MASTERDATA CREATION
  const handleSubmit = async () => {
    let data = sessionStorage.getItem('vendor');
    let vendorData = JSON.parse(data);
    const id = vendorData.data.vendorId;
const corporateId = vendorData.data.CorporateId
    const masterData = {
      vendorId: id,
      assessorId: id1,
      companyId: id2,
      CorporateId: corporateId,

      dateOfCommencement: {
        value: "",
        validation: 0,
      },
      dateOfCompletion: {
        value: "",
        validation: 0,

      },
      poCopy: {
        value: "",
        validation: 0
      },
      epfoAllotment: {
        value: "",
        validation: 0
      },
      esicAllotment: {
        value: "",
        validation: 0
      },
      pTaxRc: {
        value: "",
        validation: 0
      },
      ptEc: {
        value: "",
        validation: 0
      },
      lwf: {
        value: "",
        validation: 0
      },
      factoryLicence: {
        value: "",
        validation: 0
      },
      buildingPlanLayout: {
        value: "",
        validation: 0
      },
      stabilityCertificate: {
        value: "",
        validation: 0
      },
      concernToEstablishment: {
        value: "",
        validation: 0
      },
      concernToOperations: {
        value: "",
        validation: 0
      },
      fireAdvisory: {
        value: "",
        validation: 0
      },
      fireNoc: {
        value: "",
        validation: 0
      },
      environmentClearance: {
        value: "",
        validation: 0
      },
      medicalOrHospitalCertificate: {
        value: "",
        validation: 0
      },
      apprenticeshipRegistration: {
        value: "",
        validation: 0
      },
      neemOrNapsRegistration: {
        value: "",
        validation: 0
      },
      clraRc: {
        value: "",
        validation: 0
      },
      sAndCeRc: {
        value: "",
        validation: 0
      },
      clraLicence: {
        value: "",
        validation: 0
      },
      bocwRc: {
        value: "",
        validation: 0
      },
      ismwRc: {
        value: "",
        validation: 0
      },
      ismwLicence: {
        value: "",
        validation: 0
      },
      passaraLicence: {
        value: "",
        validation: 0
      },
      fssaiLicence: {
        value: "",
        validation: 0
      },
      wCPolicyNumber: {
        value:""
      },
      hrPolicyUndertakingAck: {
        value: "",
        validation: 0
      },
      GSTCertificate: {
        value: "",
        validation: 0
      },


    }
    try {
   const response = await api.masterData.createMasterData(masterData)
        if (response.status === 201) {
         
          setSnackbarOpen(true);
          setSnackbarMessage('VendorMasterData Created Successfully');
          sessionStorage.removeItem('vendor');
          setFormData({
            natureOfWork: '',
            vendorCompanyName: '',
            vendorName: '',
            vendorCode:'',
            vendorStateId: '',
            vendorPinCode: '',
            vendorPlaceName: '',
            vendorCompanyAddress: '',
            vendorEmail: '',
            // noOfWorkers:'',
            vendorPhoneNumber: '',
            vendorEmail1: '',
            vendorPhoneNumber1: '',
            vendorUsername: '',
            vendorPassword: '',
            vendorContractStartDate: '',
            vendorContractEndDate: '',
          });
        


        }
        else if(response.status === 400){
      
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage('MasterData Already Exists')
        }
        else{
         
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage('ERROR!! Some error occured, please try again')
          setFormData({
            natureOfWork: '',
            vendorCompanyName: '',
            vendorName: '',
            vendorCode: '',
            vendorStateId: '',
            vendorPinCode: '',
            vendorPlaceName: '',
            vendorCompanyAddress: '',
            vendorEmail: '',
            // noOfWorkers:'',
            vendorPhoneNumber: '',
            vendorEmail1: '',
            vendorPhoneNumber1: '',
            vendorUsername: '',
            vendorPassword: '',
            vendorContractStartDate: '',
            vendorContractEndDate: '',
          });

        }


    }
      catch(error) {
        console.error('An unexpected error occurred. Please try again', error);
        
        

      }
  };



  return (
    <>
      <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          
          }}
          severity="success"
          open={snackbarOpen}
          autoHideDuration={2000}
          onClose={() => setSnackbarOpen(false)}
          sx={{
            marginTop: '2.9%', 
            marginRight: '7%'
          }}
        >
          <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          severity="error"
          open={errorSnackbarOpen}
          autoHideDuration={2000}
          sx={{
            marginTop: '2.9%', 
            marginRight: '7%'
          }}
          onClose={() => {setErrorSnackbarOpen(false)}}
        >
          <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
        </Snackbar>
        <div style={{background:'#eeee'}}>
   <h4 className="p-3  text-center " style={{borderRadius:'0px 0px 0px 0px',background: 'linear-gradient(205deg, rgba(28,28,28,1) 68%, rgba(213,214,215,0) 8%)',color:'#eeee'}}>Create Vendor Profile</h4>
<div className="mt-4">
        <Grid container>
      <Grid item xs={12} sm={6}>
      <h6 className="text-secondary pb-4" style={{paddingLeft:'65px'}}>Establishment Details</h6>
          <div className={classes.detail}>
            {/* <CorporateFareIcon className={classes.icon} /> */}
            <TextField className={classes.textField} label="Principal Employer" InputLabelProps={{ shrink: true }} name="principleEmployer" value={formData.principleEmployer} onChange={handleChange} InputProps={{ readOnly: true }} />

          </div>

          <div className={classes.detail}>
            {/* <LocationOn className={classes.icon} /> */}
            <TextField   InputLabelProps={{ shrink: true }} className={classes.textField} label="Address" name="companyAddress" value={formData.companyAddress} onChange={handleChange} InputProps={{ readOnly: true }} />
          </div>
          <div className={classes.detail}>
            {/* <LocationOn className={classes.icon} /> */}
            <TextField
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              label="Place / City"
              name="placeName"
              value={formData.placeName}
              onChange={handleChange}

              InputProps={{ readOnly: true }}

            />
          </div>
          <div className={classes.detail}>
            {/* <LocationOn className={classes.icon} /> */}
            <TextField
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              label="Pincode"
              name="pinCode"
              value={formData.pinCode}
              onChange={handleChange}

              InputProps={{ readOnly: true }}

            />
          </div>
          <div className={classes.detail}>
            {/* <CorporateFareIcon className={classes.icon} /> */}
            <TextField 
              InputLabelProps={{ shrink: true }} className={classes.textField} label="Contractor" name="clientName " value={formData.clientName} onChange={handleChange} InputProps={{ readOnly: true }} />

          </div>

          <div className={classes.detail}>
            {/* <Person className={classes.icon} /> */}
            <TextField 
              InputLabelProps={{ shrink: true }} className={classes.textField} label="Contact Person Name" name="clientContactPersonName" value={formData.clientContactPersonName} onChange={handleChange} InputProps={{ readOnly: true }} />
          </div>
          <div className={classes.detail}>
            {/* <Phone className={classes.icon} /> */}
            <TextField 
              InputLabelProps={{ shrink: true }}
              className={classes.textField} label="Contact Number" name="clientContactPersonPhoneNumber" value={formData.clientContactPersonPhoneNumber} onChange={handleChange} InputProps={{ readOnly: true }} />
          </div>
          <div className={classes.detail}>
            {/* <Email className={classes.icon} /> */}
            <TextField
              InputLabelProps={{ shrink: true }}
               className={classes.textField} label="Email" name="clientContactPersonEmailId" value={formData.clientContactPersonEmailId} onChange={handleChange} InputProps={{ readOnly: true }} />
          </div>
          
        </Grid>

         <Grid xs={12} sm={6}>
         <h6 className="text-secondary pb-4" style={{paddingLeft:'60px'}}>Vendor Details</h6>
          <div className={classes.detail}>
            <TextField className={classes.textField} label="Vendor / Company Name" name="vendorCompanyName" value={formData.vendorCompanyName} onChange={handleChange} error={!!errors.vendorCompanyName}
                InputLabelProps={{ shrink: true }}
                helperText={errors.vendorCompanyName} />
          </div>
          <div className={classes.detail}>
            {/* <Person className={classes.icon} /> */}
            <TextField className={classes.textField}   InputLabelProps={{ shrink: true }}
             label="Vendor Code" name="vendorCode" value={formData.vendorCode} onChange={handleChange} error={!!errors.vendorCode}
              helperText={errors.vendorCode} />
          </div>
          <FormControl sx={{minWidth:505,marginLeft:8,marginBottom:2}}>

          <InputLabel id="demo-simple-select-label">Select State</InputLabel>
            <Select
            // style={{border:'1px solid black'}}
            InputLabelProps={{ shrink: true }}
            
               labelId="demo-simple-select-label"
          id="demo-simple-select"
              label="Select State"
              value={formData.vendorStateId}
              onChange={handleChange}
              name="vendorStateId"
              displayEmpty
              error={!!errors.vendorStateId}
            >
              {/* <MenuItem value={state}  InputLabelProps={{ shrink: true }} disabled >Select State</MenuItem> */}
              {statesInIndia.map((state, index) => (

                <MenuItem key={index} value={state}>{state}</MenuItem>
              ))}
            </Select>
            </FormControl>

        
          {errors.vendorStateId && (
            <div className="pb-3 text-center" style={{ color: 'red', fontSize: '14px' }}>
              {errors.vendorStateId}
            </div>
          )}
            <div className={classes.detail}>
            {/* <MyLocationIcon className={classes.icon} /> */}
            <TextField
              className={classes.textField}
              label="Place / City"
              InputLabelProps={{ shrink: true }}
              name="vendorPlaceName"
              value={formData.vendorPlaceName}
              onChange={handleChange}
              
              error={!!errors.vendorPlaceName}
              helperText={errors.vendorPlaceName}
            />
          </div>
          <div className={classes.detail}>
            {/* <LocationOn className={classes.icon} /> */}
            <TextField   InputLabelProps={{ shrink: true }} className={classes.textField} label="Address" name="vendorCompanyAddress" value={formData.vendorCompanyAddress} onChange={handleChange} error={!!errors.vendorCompanyAddress}
              helperText={errors.vendorCompanyAddress} />
          </div>
        
          <div className={classes.detail}>
            {/* <LocationOn className={classes.icon} /> */}
            <TextField className={classes.textField}   InputLabelProps={{ shrink: true }} label="Pincode" name="vendorPinCode" value={formData.vendorPinCode} onChange={handleChange} error={!!errors.vendorPinCode}
              helperText={errors.vendorPinCode} />
          </div>
          <div className={classes.detail}>
            {/* <Person className={classes.icon} /> */}
            <TextField 
              InputLabelProps={{ shrink: true }}
              className={classes.textField} label="Authorised Person" name="vendorName" value={formData.vendorName} onChange={handleChange} error={!!errors.vendorName}
              helperText={errors.vendorName} />
          </div>
         
          <div className={classes.detail}>
            {/* <Phone className={classes.icon} /> */}
            <TextField className={classes.textField}   InputLabelProps={{ shrink: true }} sx={{marginLeft:'42px'}} label="Contact Number" name="vendorPhoneNumber" value={formData.vendorPhoneNumber} onChange={handleChange} error={!!errors.vendorPhoneNumber}
              helperText={errors.vendorPhoneNumber} />
                <IconButton 
                  onClick={handlePhoneNumberVendor} 
                  sx={{ marginLeft: "5px" }} 
                  color="primary"
              >
                  {extraPhoneNumberVisible ? <Remove sx={{ color: "gray" }} /> : <Add sx={{ color: "gray" }} />}
              </IconButton>
          </div>
          {extraPhoneNumberVisible && (
            <div className={classes.detail}>
                <TextField 
                    className={classes.textField}
                    label="Alternative Contact Number"
                    InputLabelProps={{ shrink: true }}
                    name="vendorPhoneNumber1"
                  
                    value={formData.vendorPhoneNumber1}
                    onChange={handleChange}
                    error={!!errors.vendorPhoneNumber1}
                    helperText={errors.vendorPhoneNumber1} 
                />
            </div>
        )}
          <div className={classes.detail}>
            {/* <Email className={classes.icon} /> */}
            <TextField className={classes.textField} 
              InputLabelProps={{ shrink: true }}
               sx={{marginLeft:'42px'}} label="Email" name="vendorEmail" value={formData.vendorEmail} onChange={handleChange} error={!!errors.vendorEmail}
              helperText={errors.vendorEmail} />
               <IconButton
              onClick={handleAddEmailVendor}
              style={{ marginLeft: '5px' }}
              color="primary"
            >
              {extraEmailVendorVisible ? <Remove sx={{ color: "gray" }} /> : <Add sx={{ color: "gray" }} />}
            </IconButton>
          </div>
          {extraEmailVendorVisible && (
            <div className={classes.detail}>
              {/* <MailOutlineIcon className={classes.icon} /> */}
              <TextField className={classes.textField}
                label="Alternative Email"
                InputLabelProps={{ shrink: true }}
                name="vendorEmail1"
                value={formData.vendorEmail1}
                onChange={handleChange}
                error={!!errors.vendorEmail1}
                helperText={errors.vendorEmail1} />

            </div>
          )}
          <div className={classes.detail}>
            {/* <FormatListNumbered className={classes.icon} /> */}
            <TextField  
             InputLabelProps={{ shrink: true }}
            className={classes.textField} label="Nature Of Work" name="natureOfWork" value={formData.natureOfWork} onChange={handleChange} error={!!errors.natureOfWork}
              helperText={errors.natureOfWork} />
          </div>
         
            {/* <LocationOn className={classes.icon} /> */}
            {/* <TextField
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              label="No Of Workers"
              name="noOfWorkers"
              value={formData.noOfWorkers}
              onChange={handleChange}
              helperText={errors.noOfWorkers}
              error={!!errors.noOfWorkers}
             

            /> */}
         


          <div className={classes.detail}>
            {/* <DateRange className={classes.icon} /> */}
            <TextField
              className={classes.textField}
              label="Contract Start Date"
              InputLabelProps={{ shrink: true }}
              type="date"
              name="vendorContractStartDate"
              value={formData.vendorContractStartDate}
              onChange={handleChange}
              InputProps={{
                inputProps: {
                  max: formData.vendorContractEndDate, // Dynamically set the min date
                },
              }}
              error={!!errors.vendorContractStartDate}
              helperText={errors.vendorContractStartDate}
            />
          </div>
          <div className={classes.detail}>
            {/* <DateRange className={classes.icon} /> */}
            <TextField
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              label="Contract End Date"
              type="date"
              name="vendorContractEndDate"
              value={formData.vendorContractEndDate}
              onChange={handleChange}
              InputProps={{
                inputProps: {
                  min: formData.vendorContractStartDate, // Dynamically set the min date
                },
              }}
          
              error={!!errors.vendorContractEndDate}
              helperText={errors.vendorContractEndDate}
            />
          </div>
        

          <div className={classes.detail}>
            {/* <AccountCircle className={classes.icon} /> */}
            <TextField
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              label="Username"
              name="vendorUsername"
              value={formData.vendorUsername}
              onChange={handleChange}
             
              error={!!errors.vendorUsername}
              helperText={errors.vendorUsername}
            />
          </div>

          <div className={classes.detail}>
            {/* <Lock className={classes.icon} /> */}
            <FormControl sx={{ width: '100%' }} variant="outlined">

              <TextField
               sx={{marginLeft:'10%'}}
              className={classes.textField}
                id="outlined-adornment-password"
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff sx={{color:"black"}}/> : <Visibility sx={{color:'black'}}/>}
                      </IconButton>
                      <Tooltip title="Generate Password">
                       <IconButton
                       aria-label="generate password"
                       onClick={handleGeneratePassword}
                      edge="end"
                    >
                      <Autorenew sx={{ color: 'grey' }} />
                   </IconButton>
                   </Tooltip>
                    </InputAdornment>
                  ),
                }}

                label="Password"
                InputLabelProps={{ shrink: true }}
                name="vendorPassword"
                value={formData.vendorPassword}
                onChange={handleChange}
                error={!!errors.vendorPassword}
                helperText={errors.vendorPassword}
              />
            </FormControl>
            </div>
</Grid>
<Grid item xs={12}>
<button type="button pb-3" className="btn  btn-success float-end   mt-2 mb-2" style={{marginRight:'65px'}}  onClick={handleSave}>
        Create
      </button>
    </Grid>
</Grid>


    </div>
    </div>
    </>
  );
};

export default CompanyCard;
